import SvgIcon from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";

const VideoFileIcon = () => (
    <SvgIcon viewBox="0 0 24 24">
        <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2ZM15.8 20H14L12 16.6L10 20H8.2L11.1 15.5L8.2 11H10L12 14.4L14 11H15.8L12.9 15.5L15.8 20ZM13 9V3.5L18.5 9H13Z" fill="#E74C3C"/>
        <rect x="7" y="11" width="10" height="9" fill="#E74C3C"/>
        <path d="M13 16.5V13.5C13 12.95 12.55 12.5 12 12.5H8.5C7.95 12.5 7.5 12.95 7.5 13.5V16.5C7.5 17.05 7.95 17.5 8.5 17.5H12C12.55 17.5 13 17.05 13 16.5ZM13.5 15.25L16.5 17.5V12.5L13.5 14.75V15.25Z" fill="#E5E5E5"/>
    </SvgIcon>
);

export default VideoFileIcon;
